function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "promo_svg__a",
  d: "M0 0h683.2v159.6H0z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "promo_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  fillRule: "evenodd",
  xlinkHref: "#promo_svg__a"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#e9d4ba",
  xlinkHref: "#promo_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.225 232.4c86.212 0 214.132-100.507 154.829-170.614S141.437-40.6 55.225-40.6c-86.211 0-174.682 33.6-135.1 118.065C-40.292 161.93-30.986 232.4 55.225 232.4z",
  fill: "#aac0a8",
  mask: "url(#promo_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M513.025 352.8c86.212 0 214.132-100.507 154.829-170.614S599.237 79.8 513.025 79.8s-174.682 33.6-135.1 118.065c39.583 84.465 48.889 154.935 135.1 154.935z",
  fill: "#ad958d",
  mask: "url(#promo_svg__b)"
}));

function SvgPromo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 160,
    width: 684
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE2MCIgdmlld0JveD0iMCAwIDY4NCAxNjAiIHdpZHRoPSI2ODQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGlkPSJhIiBkPSJtMCAwaDY4My4xOTk5ODh2MTU5LjU5OTk5N2gtNjgzLjE5OTk4OHoiLz48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjx1c2UgZmlsbD0iI2U5ZDRiYSIgeGxpbms6aHJlZj0iI2EiLz48cGF0aCBkPSJtNTUuMjI1NDM4MSAyMzIuNDAwMDAxYzg2LjIxMTY0NzkgMCAyMTQuMTMxNjM2OS0xMDAuNTA3NDI1IDE1NC44Mjg1MTI5LTE3MC42MTQwNjQ2LTU5LjMwMzEyNC03MC4xMDY2MzkzOC02OC42MTY4NjUtMTAyLjM4NTkzNTctMTU0LjgyODUxMjktMTAyLjM4NTkzNTctODYuMjExNjQ4IDAtMTc0LjY4MjgwOTEgMzMuNTk5OTk5NDItMTM1LjA5OTk5NzcgMTE4LjA2NDg0MTcgMzkuNTgyODExOCA4NC40NjQ4NDI2IDQ4Ljg4ODM0OTcgMTU0LjkzNTE1ODYgMTM1LjA5OTk5NzcgMTU0LjkzNTE1ODZ6IiBmaWxsPSIjYWFjMGE4IiBtYXNrPSJ1cmwoI2IpIi8+PHBhdGggZD0ibTUxMy4wMjU0MyAzNTIuNzk5OTk5Yzg2LjIxMTY0OCAwIDIxNC4xMzE2MzctMTAwLjUwNzQyNSAxNTQuODI4NTEzLTE3MC42MTQwNjUtNTkuMzAzMTI0LTcwLjEwNjYzOS02OC42MTY4NjUtMTAyLjM4NTkzNTQtMTU0LjgyODUxMy0xMDIuMzg1OTM1NHMtMTc0LjY4MjgwOSAzMy41OTk5OTk0LTEzNS4wOTk5OTcgMTE4LjA2NDg0MTRjMzkuNTgyODExIDg0LjQ2NDg0MyA0OC44ODgzNDkgMTU0LjkzNTE1OSAxMzUuMDk5OTk3IDE1NC45MzUxNTl6IiBmaWxsPSIjYWQ5NThkIiBtYXNrPSJ1cmwoI2IpIi8+PC9nPjwvc3ZnPg==";
export { SvgPromo as ReactComponent };